export default __webpack_public_path__ + "static/media/envelope-phone.94285ecf.svg";